// extracted by mini-css-extract-plugin
export default {"tsAndCsLink":"tsAndCs_tsAndCsLink"};